import mutations from '@/store/profile/mutations';
import actions from '@/store/profile/actions';
const Form = {
    state: {
        title: null,
        firstName: null,
        familyName: null,
        otherNames: null,
        mobileNumber: null,
        alternativeContactNumber: null
    },
    mutations,
    actions
};
export default Form;
